import { useNavigate, useParams } from 'react-router-dom';

import { EPermissionAction, EPermissionGroup } from 'common/permissions.types';
import { permissionsUtil } from 'utils/permissionsUtil';

import PortalHeader from '../../components/PortalHeader/PortalHeader';

import { PlansTable } from './components/PlansTable';

export const Plans = () => {
  const navigate = useNavigate();
  const { publisherId } = useParams();

  return (
    <div className="opacity-100 pointer-events-auto">
      <PortalHeader
        title="Plans List"
        primaryButtonText="Create New Plan"
        onPrimaryButtonClick={() => navigate('./form')}
        primaryButtonState={{
          disabled: !permissionsUtil.isActionEnabled(
            null,
            EPermissionGroup.SUBSCRIPTIONS,
            EPermissionAction.MANAGE,
            publisherId
          )
        }}
        isCreateButton
      />

      <div className="px-9 pb-9 pt-2.5">
        <PlansTable />
      </div>
    </div>
  );
};
